import React, { useEffect, useRef, useState } from 'react';
import DrawerSideMenu from './drawer-sidemenu/DrawerSideMenu';
import Introduction from './Introduction';
import { useOnboarding } from 'src/features/onboarding/hooks.tsx/use-onboarding';

import { OnboardingPacketDto } from 'src/api/v2';
import { SideMenuSubpageContext } from '../constants/Context';
import { NavigationWrapper, renderPage, SidemenuPaths } from './drawer-sidemenu/routes';
import useSiteimprove from 'src/hooks/use-siteimprove';
import { SITEIMPROVE_DECLARATIONS } from 'src/features/tracking/constants';
import { useLocation } from 'react-router-dom';

const OnboardingSideMenu: React.FC = () => {
  const { priorityPacket } = useOnboarding();
  const siteimprove = useSiteimprove();
  const [flow, setFlow] = useState<OnboardingPacketDto | null>(null);
  const [page, setPage] = useState<SidemenuPaths>('index');
  const previousPage = useRef<SidemenuPaths | null>(null);
  const location = useLocation();

  useEffect(() => {
    if (previousPage.current === null) {
      previousPage.current = page;
      return;
    }

    if (previousPage.current !== page) {
      siteimprove?.log(SITEIMPROVE_DECLARATIONS.HELP_AND_SUPPORT_PAGE_VIEW.id, page, location.pathname);
      previousPage.current = page;
    }
  }, [page, siteimprove, location.pathname]);

  return (
    <SideMenuSubpageContext.Provider value={{ page, setPage, flow, setFlow }}>
      <DrawerSideMenu>
        {priorityPacket && <Introduction onboardingPacket={priorityPacket} />}
        <NavigationWrapper path={page}>{renderPage(page)}</NavigationWrapper>
      </DrawerSideMenu>
    </SideMenuSubpageContext.Provider>
  );
};

export default OnboardingSideMenu;
